<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_BookingLog')"
    width="740px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view settlement-notice"
  >
    <div class="main-content">
      <div class="section grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :show-side-bar="false"
          :row-data="rowData"
        />
      </div>
    </div>
    <el-dialog
      v-el-drag-dialog
      :title="$t('SeaExport.updateOrderContent')"
      :visible.sync="updateOrderContentVisible"
      width="45%"
      :show-close="true"
      append-to-body
    >
      <pre>{{ updateOrderContent }}</pre>
    </el-dialog>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { queryEDISendLogMessage } from '@/api/seaExport/edi'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import { DocumentManage } from '@/utils/commonUtil'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'BookingLogDialog',
  components: { CargoAgGrid, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    sendType: {
      type: String,
      required: true
    },
    isHz: {
      type: Boolean,
      default: () => false
    },
    // ediType: {
    //   type: String,
    //   required: true
    // },
    jobUuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      documentManage: new DocumentManage(),
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      gridApi: null,
      updateOrderContentVisible: false,
      updateOrderContent: ''
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    columnDefs() {
      const columnDefs = [
        { headerName: this.$t('CargoMsg.Cargo_Sender'), field: 'createdBy', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SendDate'), field: 'dateCreated', width: 160 },
        { headerName: this.$t('CargoMsg.Cargo_VersionNo'), field: 'sendVersion', width: 80 },
        { headerName: this.$t('CargoMsg.Cargo_Type'), field: 'templateDescribe', width: 80,
          valueFormatter: (params) => {
            const value = ColumnUtils.bookingTransportModeLabelFunc(params.data.transportMode)
            if (!StrUtils.isEmpty(value)) {
              return value
            }
            return params.data.templateDescribe ? 'FTP' : 'API'
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_TemplateDescribe'), field: 'templateDescribe', width: 140 },
        { headerName: this.$t('SeaExport.ReceiptType'),
          field: 'receiptType',
          width: 120,
          valueFormatter: (params) => {
            if (params.data.type === EdiType.BC_EDI_TYPE.code || params.data.type === EdiType.EDI_CONFIRM_TYPE.code || params.data.ediSendType === 20) {
              return this.isZh ? EdiType.EDI_CONFIRM_TYPE.chineseName : EdiType.EDI_CONFIRM_TYPE.englishName
            } else if (params.data.type === EdiType.AK_EDI_TYPE.code ||
              params.data.type === EdiType.RL_EDI_TYPE.code ||
              params.data.type === EdiType.EDI_COMMUNICATE_TYPE.code) {
              return this.isZh ? EdiType.EDI_COMMUNICATE_TYPE.chineseName : EdiType.EDI_COMMUNICATE_TYPE.englishName
            } else if (params.data.ediSendType === 21) {
              return this.isZh ? EdiType.BOOOKING_CANCEL.chineseName : EdiType.BOOOKING_CANCEL.englishName
            }
            return ''
          }
        },
        { headerName: this.$t('SeaExport.ReceiptContent'),
          field: 'returnMessage',
          width: 140
        },
        { headerName: this.$t('SeaExport.SendAisle'),
          field: 'sendType',
          width: 120,
          valueFormatter: (params) => {
            const sendType = ChargeItemTarget.getChargeItemTargetByCode2(params.value)
            if (sendType) {
              return this.isZh ? sendType.chineseName : sendType.code
            }
            return ''
          }
        },
        { headerName: this.$t('SeaExport.viewDGStuffing'),
          field: 'content',
          width: 120,
          cellRenderer: (params) => {
            // 只有ediSendType为FTP回执时才会有更新内容
            if (params.data.ediSendType === 20 && params.value) {
              const text = this.$t('SeaExport.updateOrderContent')
              const methodPath = this.documentManage.getPath('updateOrderContentDialog')
              let data = ''
              if (params.value.concat('\\n')) {
                data = params.value.replace(/\n/g, '\\n').replace(/'/g, '\\\'')
              }
              return `<a href="javascript:void(0)"  style="font-size:10px; color: #0d76c1;" onclick="${methodPath}('${data}')">${text}</a>`
            } else {
              return ''
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BookingState'),
          field: 'bookingState',
          width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.jobBookingState(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_ErrorMsg'), field: 'errorMsg', width: 150, minWidth: 150 }
      ]
      if (this.isHz) {
        columnDefs.push({ headerName: this.$t('CargoMsg.Cargo_SendType'), field: 'type', width: 140,
          valueFormatter: (params) => {
            if (params.data.type === EdiType.BOOKING_EDI_TYPE.code) {
              return this.isZh ? EdiType.BOOKING_EDI_TYPE.chineseName : EdiType.BOOKING_EDI_TYPE.englishName
            } else if (params.data.type === EdiType.SHIPPING_EDI_TYPE.code) {
              return this.isZh ? EdiType.SHIPPING_EDI_TYPE.chineseName : EdiType.SHIPPING_EDI_TYPE.englishName
            } else if (params.data.type === EdiType.CONTAINERS_EDI.code) {
              return this.isZh ? EdiType.CONTAINERS_EDI.chineseName : EdiType.CONTAINERS_EDI.englishName
            } else if (params.data.type === EdiType.CANCELLATION_EDI.code) {
              return this.isZh ? EdiType.CANCELLATION_EDI.chineseName : EdiType.CANCELLATION_EDI.englishName
            }
            return ''
          }
        })
      }
      return columnDefs
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('updateOrderContentDialog', function(data) {
      self.updateOrderContentDialog(data)
    })
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let ediTypes = [
        EdiType.BOOKING_EDI_TYPE.code,
        EdiType.BILL_EDI_TYPE.code,
        EdiType.BC_EDI_TYPE.code,
        EdiType.AK_EDI_TYPE.code,
        EdiType.RL_EDI_TYPE.code,
        EdiType.EDI_CONFIRM_TYPE.code,
        EdiType.EDI_COMMUNICATE_TYPE.code]
      if (this.isHz) {
        ediTypes = [
          EdiType.BOOKING_EDI_TYPE.code,
          EdiType.BC_EDI_TYPE.code,
          EdiType.AK_EDI_TYPE.code,
          EdiType.RL_EDI_TYPE.code,
          EdiType.EDI_CONFIRM_TYPE.code,
          EdiType.EDI_COMMUNICATE_TYPE.code,
          EdiType.CONTAINERS_EDI.code,
          EdiType.CANCELLATION_EDI.code,
          EdiType.SHIPPING_EDI_TYPE.code]
      }
      queryEDISendLogMessage({ jobUuid: this.jobUuid, ediTypes: ediTypes }).then(res => {
        this.rowData = res.data
      })
    },
    onCancel() {
      this.$emit('close')
    },
    updateOrderContentDialog(data) {
      this.updateOrderContentVisible = true
      this.updateOrderContent = data
    }
  }
}
</script>

<style lang="scss">
</style>
